import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';
import css from './relatedcases.scss';
import CaseElement from '../case/caseElementGeneric';
import baseUrl from '../../utils/baseUrl';
import axios from 'axios';
import Spinner from '../../components/svg/spinner';
import SweetScroll from 'sweet-scroll';

export default class RelatedCases extends Component {
	static propTypes = {};
	constructor(props) {
		super(props);

		this.state = {
			active: false,
			cases: [],
			done: false,
			offset: 5,
			next: false,
			waiting: false,
		};

		this.didScroll = false;
	}

	componentWillMount() {
		this.state.cases = this.props.cases;
	}

	componentWillUpdate(nextProps, nextState) {
		if (this.props.parentSlug !== nextProps.parentSlug || this.props.cases !== nextProps.cases) {
			this.state.cases = nextProps.cases;
			this.state.done = false;
			this.state.active = false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return(
			this.state !== nextState ||
			this.props.id !== nextProps.id ||
			this.props.names !== nextProps.names ||
			this.props.cases !== nextProps.cases
		);
	}

	componentDidMount() {
	    if(window.location.hash && window.location.hash == '#related-cases' && !this.didScroll) {
			const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 });
			scroller.to('#related-cases');
			this.didScroll = true;
		}
	}

	render() {
		let uid = 'related-cases-' + this.props.id;
		let moreText = 'Load more (' + (this.props.total - this.state.cases.length) + ')';
		let arrowClass = 'related-cases__load-more__arrow';

		let relatedClass = 'related-cases span14';

		if (this.props.profile) {
			relatedClass = 'related-cases related-cases--profile span14';
			moreText = 'Load more (' + (this.props.cases.length - 6) + ')';
		}

		if (this.state.active) {
			relatedClass += ' active';
			moreText = 'Show less';
			arrowClass = 'related-cases__load-more__arrow related-cases__load-more__arrow--active';
		}

		return (
			<div>
				<section className={relatedClass} key={uid} ref='relatedCases' id='related-cases'>
					<div className='related-cases__fill span2 hide-mobile'></div>
					<div className='related-cases__top span12 span14-mobile'>
						<h2 className='related-cases__title'>More FWAs from {this.props.names}</h2>
					</div>
					<CaseList cases={this.state.cases} browser={this.props.browser} />
				</section>
				{!this.state.done && this.props.cases.length > 5 && !this.props.profile && (this.props.total - this.state.cases.length > 0) && (
				<a href='#' ref='moreButton' className='related-cases__load-more span8 span100p-mobile pixel-pattern' onClick={(event) => this.fetchMore(event)}>
					<span className='span2 span4-mobile related-cases__load-more__arrow-holder'>
						{this.state.waiting && (
							<Spinner className='related-cases__load-more__spinner' />
						) || (
							<span className={arrowClass}></span>
						)}
					</span>
					{moreText}
				</a>
				) || this.props.cases.length > 5 && this.props.profile && !this.state.done && (
				<a href='#' ref='moreButton' className='related-cases__load-more span8 span100p-mobile pixel-pattern' onClick={(event) => this.onClick(event)}>
					<span className='span2 span4-mobile related-cases__load-more__arrow-holder'>
						<span className={arrowClass}></span>
					</span>
					{moreText}
				</a>
				)}
			</div>
		);
	}

	fetchMore(e){
		e.preventDefault();

		if (!this.state.done) {

			this.setState({
				waiting: true,
			});

			let offset = 6;
			let url = '';

			if (this.state.next) {
				url = this.state.next;
			} else {
				url = baseUrl + '/api/' + this.props.typeSlug + '/' + this.props.parentSlug + '/related?limit=6' + '&offset=' + offset;
			}

			const a = document.createElement('a');
			a.href = url;
			url = a.pathname + a.search;

			axios.get(url).then((response) => {
				forEach(response.data.cases, (single) => {
					this.state.cases.push(single);
				});

				if (!response.data.next) {
					this.state.done = true;
				}

				this.setState({
					cases: this.state.cases,
					next: response.data.next,
					waiting: false,
					done: this.state.done,
				});
			}).catch((response) => {
				console.log('fetching related cases error');
				console.log(response);
			});
		}
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	onClick(e) {
		e.preventDefault();

		this.setState({
			...this.state,
			active: !this.state.active,
		});
	}
}

export class CaseList extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		cases: PropTypes.array.isRequired,
		contentComp: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.func,
		]).isRequired,
	};

	static defaultProps = {
		contentComp: false,
	};

	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};
	}

	render() {
		return (
			<ul className='related-cases__case-holder span12 span14-mobile'>
				{this.props.cases.map(this.renderCase.bind(this))}
				<li className='related-cases__case-fill span4 span6-tablet span14-mobile'></li>
				<li className='related-cases__case-fill span4 span6-tablet span14-mobile'></li>
			</ul>
		);
	}

	renderCase(caseItem, i) {
		let uid = 'case' + i;
		let classes = 'related-cases__case span4 span6-tablet span14-mobile';

		if (this.props.browser.window.width < 1200) {
			if (i % 2 === 0) {
				classes += ' no-margin';
			}
		} else {
			if (i % 3 === 0) {
				classes += ' no-margin';
			}
		}

		return (
			<li key={uid} className={classes}>
				<CaseElement caseItem={caseItem} browser={this.props.browser} showPoints={true} contentComp={this.props.contentComp} />
			</li>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/relatedcases/relatedcases.js
 **/